export default __webpack_public_path__ + "static/media/house-keeper.749e48a6.svg";